import { Component, OnInit} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { IsAuthenticatedUsecase, LoginUserUsecase } from 'src/app/core/useCases/credentials.usecases';
import { NotificationService } from '../../services/notification.service';
import { maxPasswordLength, minPasswordLength } from 'src/global';
import { Credentials } from 'src/app/core/models/credentials.model';

@Component({
    selector: 'app-login-page',
    templateUrl: './login.page.html',
    styleUrls: ['./login.page.scss'],
    standalone: false,
})
export class LoginPageComponent implements OnInit {
  user: any = {};
  message: string = "";
  loginForm: FormGroup;
  hidePW = true;

  constructor(
    public router: Router,
    private formBuilder: FormBuilder,
    private isAuthenticated: IsAuthenticatedUsecase,
    private loginUser: LoginUserUsecase,
    private notificationService: NotificationService,
  ) {
    this.loginForm = this.formBuilder.group({
      email: ['', Validators.required],
      password: ['', Validators.compose([
        Validators.required,
        Validators.minLength(minPasswordLength),
        Validators.maxLength(maxPasswordLength)],
      )],
    });
  }

  submitForm() {
    this.login();
  }

  ngOnInit() {
    this.isAuthenticated.execute().subscribe(loggedIn => {
      if (loggedIn) {
        this.router.navigateByUrl('/home');
      }
    });
  }

  login() {
    const data = this.loginForm.value;
    let credentials: Credentials = {
      email: data['email'],
      password: data['password']
    };

    this.loginUser.execute(credentials).subscribe(loggedIn => {
      if (loggedIn) {
        this.router.navigateByUrl('/home');
      }
      else {
        this.loginForm.patchValue({
          password: ""
        })
        this.notificationService.notifyError("Could not log in with those credentials.");
      }
    });
  }
}
